import {Inject, Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import {CITY, Source} from '../common/const';
import 'rxjs/add/observable/combineLatest';


@Injectable()
export class RealTimeContextService {

  public mobilePopup = new Subject<any>();
  public listenerLayerLoading = new Subject();
  private loadingList = [];
  private mode = new BehaviorSubject<any>({mode: 'live'});
  private sources = new BehaviorSubject<any>(
      (() => {
        const result = [];
        for (const s of Object.keys(Source)) {
          if (isNaN(Number(Source[s]))) {
            result.push(parseInt(s, 10));
          }
        }
        return result;
      })()
  );
  private categories = new BehaviorSubject<any>(this._initCategories());
  private bbox = new Subject<Array<any>>();
  private elementsForPopup = [];
  private elementsForPopupSubject = new Subject<Array<any>>();

  mode$ = this.mode.asObservable();
  sources$ = this.sources.asObservable();
  categories$ = this.categories.asObservable();
  bbox$ = this.bbox.asObservable();
  elementsForPopup$ = this.elementsForPopupSubject.asObservable();
  cityVariables = new Subject<any>();


  realTimeLayersContext$ = Observable.combineLatest(
      this.mode,
      this.sources,
      this.categories
  );

  constructor(@Inject(CITY) private city) {
  }

  getMode() {
    return this.mode.value;
  }

  setMode(mode: any) {
    this.mode.next(mode);
  }

  getSources() {
    return this.sources.value;
  }

  setSources(sources: Array<number>) {
    this.sources.next(sources);
  }

  getCategories() {
    return this.categories.value;
  }

  setCategories(categories: any) {
    this.categories.next(categories);
  }

  _initCategories() {
    return this.city;
  }

  setBbox(categories: Array<string>) {
    this.categories.next(categories);
  }

  loadPopup(popup) {
    this.elementsForPopup.push(popup);
    this.elementsForPopupSubject.next(this.elementsForPopup);
  }

  closePopup() {
    this.elementsForPopup = [];
    this.elementsForPopupSubject.next(this.elementsForPopup);
  }

  loadMobilePopup(html) {
    this.mobilePopup.next(html);
  }

  addToLoading(layer) {
    this.loadingList.push(layer);
    this.listenerLayerLoading.next(this.loadingList);
  }

  removeFromLoading() {
    this.loadingList.pop();
    this.listenerLayerLoading.next(this.loadingList);
  }

}



// WEBPACK FOOTER //
// ./src/app/real-time/real-time-context.service.ts